<app-price-filter></app-price-filter>
<!-- <app-fare-families-filter></app-fare-families-filter> -->
<!-- <div class="septor"></div> 
<app-departure-from-filter></app-departure-from-filter> -->
<!-- <div class="septor"></div> 
<app-arrival-to-filter></app-arrival-to-filter> -->
<div class="septor"></div>
<app-stops-filter></app-stops-filter>
<div class="septor"></div>
<!-- <app-preferences-filter></app-preferences-filter> -->
<app-departure-time-filter></app-departure-time-filter>
<div class="septor"></div>
<app-arrival-time-filter></app-arrival-time-filter>
<!-- <div class="septor"></div> -->
<!-- <app-fare-type-filter></app-fare-type-filter> -->
<div class="septor"></div>
<app-airlines-filter></app-airlines-filter>
<div class="septor"></div>
<!-- <app-cabin-class-filter></app-cabin-class-filter> -->
 <!-- <app-airports-nearby-filter></app-airports-nearby-filter> -->
<app-stopover-city-filter></app-stopover-city-filter> 